const css = `.user-panel .user-panel-header {
  display: flex;
  align-items: center;
  gap: 16px;
}
.user-panel .user-panel-header h4 {
  margin-right: 12px;
}
.user-panel .user-form:not(:has(.feature-picker)) {
  padding-bottom: calc(var(--space-8) + var(--space-6));
}
.user-panel .user-form .select-role-row {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.user-panel .user-form .select-role-row .form-field {
  width: 50%;
}
.user-panel .user-form .select-role-row .switch {
  align-items: start;
}
.user-panel .user-form .email-field-container {
  min-height: 48px;
  display: flex;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;
}
.user-panel .user-form .email-field-container .p-inputtext {
  width: 100%;
}
.user-panel .user-form .email-field-container p {
  margin-left: 12px;
}
.user-panel .user-form .email-field-container .p-button {
  padding: 0;
}
.user-panel .app-status {
  display: flex;
  align-items: center;
  gap: 8px;
}
.user-panel .app-status i {
  font-size: var(--font-size-xl);
}
.user-panel .app-status i.success {
  color: var(--success);
}
.user-panel .app-status i.error {
  color: var(--danger);
}
.user-panel .app-status span {
  color: var(--text-color);
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL29wdC9yZW5kZXIvcHJvamVjdC9zcmMvc3JjL2NvbXBvbmVudHMvVXNlclBhbmVsIiwic291cmNlcyI6WyJVc2VyUGFuZWwuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDRTtFQUNFO0VBQ0E7RUFDQTs7QUFDQTtFQUNFOztBQUtGO0VBQ0U7O0FBRUY7RUFDRTtFQUNBO0VBQ0E7O0FBQ0E7RUFDRTs7QUFFRjtFQUNFOztBQUlKO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtFQUNFOztBQUdGO0VBQ0U7O0FBR0Y7RUFDRTs7QUFLTjtFQUNFO0VBQ0E7RUFDQTs7QUFFQTtFQUNFOztBQUVBO0VBQ0U7O0FBR0Y7RUFDRTs7QUFJSjtFQUNFIiwic291cmNlc0NvbnRlbnQiOlsiLnVzZXItcGFuZWwge1xuICAudXNlci1wYW5lbC1oZWFkZXIge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICBnYXA6IDE2cHg7XG4gICAgaDQge1xuICAgICAgbWFyZ2luLXJpZ2h0OiAxMnB4O1xuICAgIH1cbiAgfVxuXG4gIC51c2VyLWZvcm0ge1xuICAgICY6bm90KDpoYXMoLmZlYXR1cmUtcGlja2VyKSkge1xuICAgICAgcGFkZGluZy1ib3R0b206IGNhbGModmFyKC0tc3BhY2UtOCkgKyB2YXIoLS1zcGFjZS02KSk7XG4gICAgfVxuICAgIC5zZWxlY3Qtcm9sZS1yb3cge1xuICAgICAgd2lkdGg6IDEwMCU7XG4gICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAganVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuO1xuICAgICAgLmZvcm0tZmllbGQge1xuICAgICAgICB3aWR0aDogNTAlO1xuICAgICAgfVxuICAgICAgLnN3aXRjaCB7XG4gICAgICAgIGFsaWduLWl0ZW1zOiBzdGFydDtcbiAgICAgIH1cbiAgICB9XG5cbiAgICAuZW1haWwtZmllbGQtY29udGFpbmVyIHtcbiAgICAgIG1pbi1oZWlnaHQ6IDQ4cHg7XG4gICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICAgIGdhcDogMjRweDtcbiAgICAgIGZsZXgtd3JhcDogd3JhcDtcblxuICAgICAgLnAtaW5wdXR0ZXh0IHtcbiAgICAgICAgd2lkdGg6IDEwMCU7XG4gICAgICB9XG5cbiAgICAgIHAge1xuICAgICAgICBtYXJnaW4tbGVmdDogMTJweDtcbiAgICAgIH1cblxuICAgICAgLnAtYnV0dG9uIHtcbiAgICAgICAgcGFkZGluZzogMDtcbiAgICAgIH1cbiAgICB9XG4gIH1cblxuICAuYXBwLXN0YXR1cyB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgIGdhcDogOHB4O1xuXG4gICAgaSB7XG4gICAgICBmb250LXNpemU6IHZhcigtLWZvbnQtc2l6ZS14bCk7XG5cbiAgICAgICYuc3VjY2VzcyB7XG4gICAgICAgIGNvbG9yOiB2YXIoLS1zdWNjZXNzKTtcbiAgICAgIH1cblxuICAgICAgJi5lcnJvciB7XG4gICAgICAgIGNvbG9yOiB2YXIoLS1kYW5nZXIpO1xuICAgICAgfVxuICAgIH1cblxuICAgIHNwYW4ge1xuICAgICAgY29sb3I6IHZhcigtLXRleHQtY29sb3IpO1xuICAgIH1cbiAgfVxufVxuIl19 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
